// формат даты в виде ЧЧ:ММ если больше часа и ММ если меньше часа
export const formatTotalTime = (ms: number) => {
	let remain = ms;

	const hours = Math.floor(remain / (1000 * 60 * 60));
	remain = remain % (1000 * 60 * 60);

	const minutes = Math.floor(remain / (1000 * 60));

	if (hours >= 1) {
		if (minutes !== 0) {
			return `${hours} ч ${minutes} мин`;
		}
		return `${hours} ч`;
	}

	if (hours < 1) {
		return `${minutes} мин`;
	}
};
